// extracted by mini-css-extract-plugin
export default {"container":"user-chat-message_container__QcFvW","message":"user-chat-message_message__AGiUE"};